import { Button } from 'flowbite-react'
import { useNavigate } from 'react-router'

type PageInternalErrorProps = {
  error?: any
  back?: boolean
}

export const PageInternalError = ({ error, back }: PageInternalErrorProps) => {
  const navigate = useNavigate()

  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Oops! Something went wrong</h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          Our team has been notified and we&apos;re working hard to fix it. Please try again later.
        </p>
        {process.env.NODE_ENV === 'development' && error && (
          <div className="relative mx-auto max-w-full">
            <div className="rounded-md bg-gray-900 p-4 text-white">
              <div className="max-h-96 overflow-y-auto">
                <pre id="code" className="text-wrap text-left text-gray-300">
                  <code>
                    Error: {error.status} {error.message}
                  </code>
                  {error.data && <code>{JSON.stringify(error.data, null, 2)}</code>}
                  {error.stack && <code>{error.stack}</code>}
                </pre>
              </div>
            </div>
          </div>
        )}
        <div className="mt-4 flex items-center justify-center gap-x-6">
          <Button onClick={() => (back ? navigate(-1) : window.location.reload())}>
            {back ? 'Close' : 'Reload the page'}
          </Button>
        </div>
      </div>
    </main>
  )
}
